import { useState } from 'react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';
import UsersListpendingPage from 'pages/users/Listpending';

export default function HomePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="HomePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Home"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                <div className="">
                                    <DataSource   apiPath="components_data/home_data_component" firstRecord={true} showLoading={false}>
                                        {
                                        ({ response, loading, reload }) => 
                                        <>
                                        <div >
                                            <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                <div className="flex align-items-center gap-3">
                                                    <div style={{width:'auto'}}>
                                                        <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                        </div>
                                                        <div>
                                                            <div className="font-medium text-lg">Total Mandate</div>
                                                            {loading && 
                                                            <div className="p-2">
                                                                <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                            </div>
                                                            }
                                                            {response && 
                                                            <div className="font-bold"> {JSON.stringify(response.cntauth)}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                        <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                            }
                                        </DataSource>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                    <div className="">
                                        <DataSource   apiPath="components_data/home_data_component_2" firstRecord={true} showLoading={false}>
                                            {
                                            ({ response, loading, reload }) => 
                                            <>
                                            <div >
                                                <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                    <div className="flex align-items-center gap-3">
                                                        <div style={{width:'auto'}}>
                                                            <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                            </div>
                                                            <div>
                                                                <div className="font-medium text-lg">Total Loan</div>
                                                                {loading && 
                                                                <div className="p-2">
                                                                    <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                </div>
                                                                }
                                                                {response && 
                                                                <div className="font-bold"> {JSON.stringify(response.sumpr)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                            <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                        </div>
                                                    </div>
                                                </div>
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                        <div className="">
                                            <DataSource   apiPath="components_data/home_data_component_3" firstRecord={true} showLoading={false}>
                                                {
                                                ({ response, loading, reload }) => 
                                                <>
                                                <div >
                                                    <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                        <div className="flex align-items-center gap-3">
                                                            <div style={{width:'auto'}}>
                                                                <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                                </div>
                                                                <div>
                                                                    <div className="font-medium text-lg">Total EMI</div>
                                                                    {loading && 
                                                                    <div className="p-2">
                                                                        <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                    </div>
                                                                    }
                                                                    {response && 
                                                                    <div className="font-bold"> {JSON.stringify(response.sumamort)}</div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                            <div className="">
                                                <DataSource   apiPath="components_data/home_data_component_4" firstRecord={true} showLoading={false}>
                                                    {
                                                    ({ response, loading, reload }) => 
                                                    <>
                                                    <div >
                                                        <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                            <div className="flex align-items-center gap-3">
                                                                <div style={{width:'auto'}}>
                                                                    <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                                    </div>
                                                                    <div>
                                                                        <div className="font-medium text-lg">Total Collection</div>
                                                                        {loading && 
                                                                        <div className="p-2">
                                                                            <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                        </div>
                                                                        }
                                                                        {response && 
                                                                        <div className="font-bold"> {JSON.stringify(response.sumcollect)}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                    <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </>
                                                        }
                                                    </DataSource>
                                                </div>
                                            </div>
                                            <div className="sm:col-12 comp-grid" >
                                                <div className="">
                                                    { pageReady &&
                                                    <UsersListpendingPage isSubPage  limit="10" showHeader={true} showBreadcrumbs={true} showFooter={true} paginate={true} >
                                                    </UsersListpendingPage>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
		</main>
	);
}
